<template>
  <div class="foot-con">
<!--    <div class="text">-->
<!--      北京北矿智能科技有限公司版权所有-->
<!--    </div>-->
<!--    <div class="text small">-->
<!--      地址:北京市大兴区北兴路（东段）22号1号楼A1102  邮政编码: 102628-->
<!--    </div>-->
<!--    <div class="text small">-->
<!--      联系电话: 010 59069646/47-->
<!--    </div>-->
<!--    <div class="text small">-->
<!--      电子邮箱：beikuangzhineng@bgrimm.com-->
<!--    </div>-->
<!--    <div class="text small">-->
<!--      微信公众号：北矿智能科技有限公司-->
<!--    </div>-->

    <div class="text">
      北矿检测技术股份有限公司 / 矿冶科技集团测试研究所版权所有
    </div>
    <div class="text small">
      地址:北京市大兴区北兴路（东段）22号1号楼A701  邮政编码: 102628
    </div>
    <div class="text small">
      联系电话: 010 59069646/47
    </div>
    <div class="text small">
      电子邮箱：bkjc@bkmtc.com
    </div>
    <div class="text small">
      微信公众号：北矿检测
    </div>
    <div class="text small">
      京ICP备19053083号
    </div>
<!--    <div class="content">-->
<!--              <div class="lab-group">-->
<!--            <label class="fs24">客服电话</label>-->
<!--            <label class="fs50 mar-top-40">{{ phone }}</label>-->
<!--            <label class="col-ccc fs28 mar-top-10">{{ time }}</label>-->
<!--            <div class="consult mar-top-40">咨询客服</div>-->
<!--        </div>-->
<!--        <div class="verticalline"></div>-->
<!--        <div class="icon-group">-->
<!--            <el-image class="gzh-icon" :src="img1.pic"></el-image>-->
<!--            <label class="mar-top-20">{{img1.des}}</label>-->
<!--        </div>-->
<!--        <div class="icon-group">-->
<!--            <el-image class="xcxm-icon" :src="img2.pic"></el-image>-->
<!--            <label class="mar-top-20">{{img2.des}}</label>-->
<!--        </div>-->
<!--    </div>-->
<!--    <div class="foot-box">-->
<!--      <span style="font-family:arial;">&copy; </span>-->
<!--      2018-2022 YSHOP版权所有，并保留所有权利 豫ICP备17049587-2号-->
<!--    </div>-->
  </div>
</template>
<script>
  export default {
    name: 'v-foot',
    props: {
      obj: Object
    },
    data () {
      return {
        phone: '400 800 2100',
        time: '9:00-23:00',
        img1: {
          des: '微信公众号',
          pic: 'static/images/gzh.png'
        },
        img2: {
          des: '小程序码',
          pic: 'static/images/xcxm.png'
        }
      }
    },
    watch: {
      obj: {
        handler (nVal, oVal) {
          var data = nVal.componentContent.publicList
          for (var i = 0; i < data.length; i++) {
            if (data[i].title === '客服电话') { this.phone = data[i].des }
            if (data[i].title === '营业时间') { this.time = data[i].des }
            if (data[i].title === '微信公众号') {
              this.img1.des = data[i].des
              this.img1.pic = data[i].pic
            }
            if (data[i].title === '小程序码') {
              this.img2.des = data[i].des
              this.img2.pic = data[i].pic
            }
          }
        }
      }
    }
  }
</script>
<style scoped lang="scss">
.foot-con{
  /*height: 454px;*/
  /*height: 103px;*/
  height: 180px;
  min-width: 1440px;
  /*background-color: #0075c2;*/
  // background-color: $mainColor;
  // background-image: url('../../../static/images/foot-bg.png');
  background-image: url('../../../static/images/foot-bg4.jpg');
  color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin-top: 30px;

  .center{
    text-align: center;
  }
  .text {
    margin: 6px;
    font-size: 16px;
  }
  .small{
    font-size: 13px;
  }

  .content{
    display: flex;
    // width: 60%;
    // justify-content: space-between;
    width: 1240px;
    justify-content: space-around;
    margin-block-start: 30px;
    .lab-group{
      display: flex;
      flex-direction: column;
      label{
        font-weight: 400;
      }
      .consult{
        width: 164px;
        height: 50px;
        color: #cccccc;
        border: 1px #cccccc solid;
        line-height: 50px;
        text-align: center;
        cursor: pointer;
      }
    }
    .icon-group{
      display: flex;
      flex-direction: column;
      align-items: center;
      label{
        font-size: 20px;
        font-weight: 400;
      }
    }
    .gzh-icon{
      height: 196px;
      width: 196px;
    }
    .xcxm-icon{
      height: 196px;
      width: 196px;
    }
    .verticalline{
      height: 238px;
      width: 1px;
      background-color:#666666;
    }
  }
}
.foot-box{
  margin-top: 80px;
}
</style>



// WEBPACK FOOTER //
// src/components/base/v-foot2.vue